import React from "react";
import "./HomePageImage.css";

const HomePageImage = () => {
  return (
    <section className="jumbotron jumbotron-fluid text-center">
      <div className="container">
        <h1 className="display-3 text-white">DC NEWS</h1>
        <h2 className="display-0.5 text-white">Latest Articles</h2>
      </div>
    </section>
  );
};

export default HomePageImage;
